import { useState } from "react";
import { Box, Typography, Button, Paper, Stack } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { MuiTheme } from "../styles/MuiDataTableStyle";
import { useStateAuthValue } from "../context/AuthState";
import { useToast } from "../context/Toast/ToastProvider";
import { showToast, ToastType } from "../utils/ToastUtil";
import { LoadingModal } from "../components/Modals/LoadingModal";
import { createSingleConsultation } from "../services/singleConsultationService";
import { QRCodeSVG } from "qrcode.react";

const SingleConsultation = () => {
  const [{ userToken }] = useStateAuthValue();
  const [loading, setLoading] = useState(false);
  const [consultationLink, setConsultationLink] = useState("");
  const toastDispatch = useToast();

  const displayError = (msg) =>
    showToast(toastDispatch, msg, ToastType.ERROR, ToastType.ERROR);

  const displaySuccess = (msg) =>
    showToast(toastDispatch, msg, ToastType.SUCCESS, ToastType.SUCCESS);

  const handleGenerateConsultation = async () => {
    setLoading(true);
    const response = await createSingleConsultation(userToken, displayError);

    if (response && response.token) {
      const link = `${process.env.REACT_APP_FRONTEND_URL}/single-consultation?token=${response.token}`;
      setConsultationLink(link);
      displaySuccess("Consulta única generada exitosamente");
    } else {
      displayError("No se pudo generar la consulta única");
    }

    setLoading(false);
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(consultationLink);
    displaySuccess("Link copiado al portapapeles");
  };

  return (
    <ThemeProvider theme={MuiTheme}>
      <div className="users" style={{ maxWidth: "1035px" }}>
        {loading ? (
          <LoadingModal />
        ) : (
          <div className="users-table-container">
            <Box
              sx={{
                background: "linear-gradient(195deg, #49a3f1, #1A73E8)",
                padding: "10px",
                borderRadius: "15px",
                color: "white",
                height: "80px",
                display: "flex",
                alignItems: "center",
                width: "90%",
                position: "relative",
                bottom: "25px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "18px",
                  fontWeight: " 700",
                  letterSpacing: " 1px",
                }}
              >
                Consulta Única
              </Typography>
            </Box>

            <Paper
              sx={{
                padding: "30px",
                width: "90%",
                marginTop: "20px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "20px",
              }}
            >
              {!consultationLink ? (
                <Button
                  variant="contained"
                  size="large"
                  onClick={handleGenerateConsultation}
                  sx={{
                    background: "linear-gradient(195deg, #49a3f1, #1A73E8)",
                    color: "white",
                    padding: "12px 40px",
                    fontSize: "16px",
                    fontWeight: "600",
                    textTransform: "none",
                    borderRadius: "8px",
                    "&:hover": {
                      background: "linear-gradient(195deg, #1A73E8, #49a3f1)",
                    },
                  }}
                >
                  Generar Consulta Única
                </Button>
              ) : (
                <Stack spacing={3} alignItems="center" sx={{ width: "100%" }}>
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: "600", color: "#333" }}
                  >
                    Link de Consulta Generado
                  </Typography>

                  <Box
                    sx={{
                      padding: "20px",
                      background: "#f5f5f5",
                      borderRadius: "8px",
                      width: "100%",
                      maxWidth: "600px",
                    }}
                  >
                    <Typography
                      sx={{
                        wordBreak: "break-all",
                        fontSize: "14px",
                        color: "#555",
                      }}
                    >
                      {consultationLink}
                    </Typography>
                  </Box>

                  <Button
                    variant="outlined"
                    onClick={handleCopyLink}
                    sx={{
                      borderColor: "#1A73E8",
                      color: "#1A73E8",
                      padding: "8px 30px",
                      textTransform: "none",
                      fontWeight: "600",
                      "&:hover": {
                        borderColor: "#49a3f1",
                        background: "#f0f7ff",
                      },
                    }}
                  >
                    Copiar Link
                  </Button>

                  <Box
                    sx={{
                      padding: "20px",
                      background: "white",
                      borderRadius: "8px",
                      border: "1px solid #e0e0e0",
                      marginTop: "20px",
                    }}
                  >
                    <QRCodeSVG value={consultationLink} size={256} />
                  </Box>

                  <Typography
                    variant="body2"
                    sx={{ color: "#666", marginTop: "10px" }}
                  >
                    Escanea el código QR o comparte el link para acceder a la
                    consulta
                  </Typography>

                  <Button
                    variant="contained"
                    onClick={() => setConsultationLink("")}
                    sx={{
                      background: "linear-gradient(195deg, #49a3f1, #1A73E8)",
                      color: "white",
                      padding: "10px 30px",
                      textTransform: "none",
                      fontWeight: "600",
                      marginTop: "20px",
                      "&:hover": {
                        background: "linear-gradient(195deg, #1A73E8, #49a3f1)",
                      },
                    }}
                  >
                    Generar Nueva Consulta
                  </Button>
                </Stack>
              )}
            </Paper>
          </div>
        )}
      </div>
    </ThemeProvider>
  );
};

export default SingleConsultation;
